import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { TegelModule } from '@scania/tegel-angular-17';
import { FullscreenService } from './core/services/fullscreen.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TegelModule, MsalModule],
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  title = 'tvms-app';
  
  private readonly fullscreenService = inject(FullscreenService);

  ngOnInit(): void {
    // 监听用户第一次点击事件，触发全屏，然后移除监听
    // if(this.fullscreenService.isMobileOrTablet()) {
    //   const handleFirstClick = () => {
    //     this.fullscreenService.requestFullscreen();
    //     document.removeEventListener('click', handleFirstClick);
    //   };
    //   document.addEventListener('click', handleFirstClick);
    // }
  }
}
